// CANONICAL COPY (GH #7115). src/constants/obligations/obl-data-return-or-erasure-on-exit.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-data-return-or-erasure-on-exit',
  title: 'Verify data return or erasure on DPA termination',
  description:
    "Confirm that, on termination of processing under a DPA, personal data is returned to the controller and/or deleted by the processor per the DPA's exit clause (GDPR Art. 28(3)(g); FSR ISAE 3000 Kontrolmål D.3). Distinct from `obl-data-deletion` — this obligation focuses on the DPA-exit trigger: written evidence of return / erasure per DPA, a documented handover process, and a register of terminated DPAs with corresponding exit evidence. Review the DPA-exit standard, sample recent DPA terminations, and exit evidence records.",
  category: 'compliance',
  scfIds: ['SCF-DAT-003', 'SCF-VDR-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'DPA-exit data return / erasure procedure is published',
    },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
